module.exports = __webpack_public_path__ + "img/productVibration_7.48960ca6.png";